import { memo } from 'react'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'
import GlassmorphButton from '../../ui/GlassmorphButton'

/**
 * PasswordChangeForm - Password change form
 * Handles current and new password validation
 */
const PasswordChangeForm = memo(function PasswordChangeForm({
  passwordData,
  errors,
  isChanging,
  onSubmit,
  onChange,
  onCancel,
  t
}) {
  return (
    <div className="mt-4 p-3 bg-white/70 backdrop-blur-sm rounded-md border border-gray-200/50">
      <form onSubmit={onSubmit} className="space-y-3">
        {/* Current Password */}
        <div>
          <label htmlFor="currentPassword" className="block text-xs font-medium text-gray-700 mb-1">
            {t('profile.currentPassword', 'Current Password')}
          </label>
          <input
            type="password"
            id="currentPassword"
            name="currentPassword"
            value={passwordData.currentPassword}
            onChange={onChange}
            className={`w-full px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent ${
              errors.currentPassword ? 'border-red-500' : 'border-gray-300'
            }`}
            required
          />
          {errors.currentPassword && (
            <p className="mt-1 text-xs text-red-600">{errors.currentPassword}</p>
          )}
        </div>

        {/* New Password */}
        <div>
          <label htmlFor="newPassword" className="block text-xs font-medium text-gray-700 mb-1">
            {t('profile.newPassword', 'New Password')}
          </label>
          <input
            type="password"
            id="newPassword"
            name="newPassword"
            value={passwordData.newPassword}
            onChange={onChange}
            className={`w-full px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent ${
              errors.newPassword ? 'border-red-500' : 'border-gray-300'
            }`}
            required
          />
          {errors.newPassword && (
            <p className="mt-1 text-xs text-red-600">{errors.newPassword}</p>
          )}
        </div>

        {/* Confirm Password */}
        <div>
          <label htmlFor="confirmPassword" className="block text-xs font-medium text-gray-700 mb-1">
            {t('profile.confirmPassword', 'Confirm Password')}
          </label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={passwordData.confirmPassword}
            onChange={onChange}
            className={`w-full px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-primary focus:border-transparent ${
              errors.confirmPassword ? 'border-red-500' : 'border-gray-300'
            }`}
            required
          />
          {errors.confirmPassword && (
            <p className="mt-1 text-xs text-red-600">{errors.confirmPassword}</p>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex gap-2 pt-2">
          <GlassmorphButton
            type="submit"
            variant="primary"
            icon={CheckIcon}
            disabled={isChanging}
            size="sm"
            className="flex-1 px-3 py-2 text-xs font-medium"
          >
            {isChanging ? t('common.changing', 'Changing...') : t('profile.changePassword', 'Change Password')}
          </GlassmorphButton>
          <GlassmorphButton
            type="button"
            variant="secondary"
            icon={XMarkIcon}
            onClick={onCancel}
            disabled={isChanging}
            size="sm"
            className="flex-1 px-3 py-2 text-xs font-medium"
          >
            {t('common.cancel', 'Cancel')}
          </GlassmorphButton>
        </div>
      </form>
    </div>
  )
})

export default PasswordChangeForm
